import { createMuiTheme } from '@material-ui/core/styles';

// import blue from '@material-ui/core/colors/blue';

// const theme = createMuiTheme({
//   palette: {
//     primary: blue,
//   },
// });

const palette = {
  primary: { main: '#f6bb00' },
  secondary: { main: '#e55353' }
};

const themeName = 'xiekeyun';

const overrides = {
  MuiCardHeader: { // Name of the component ⚛️ / style sheet
    title: { // Name of the rule
      fontSize: '0.875rem', //14px
    },
  },
  MuiCard: {
    root: { marginTop: 10 }
  },
  MuiInputBase: {
    input: { fontSize: '0.875rem' }
  },
  MuiFormHelperText: {
    contained: { margin: '8px 0 0' }
  }
};

const typography = {
  useNextVariants: true
};

export default createMuiTheme({ palette, overrides, themeName, typography });
